
export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Why Choose My Marketing Horizon?
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              With years of experience in digital marketing, we've helped hundreds of businesses 
              expand their reach and achieve remarkable growth through strategic advertising campaigns.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 flex items-center justify-center bg-orange-500 rounded-full">
                  <i className="ri-trophy-line text-white text-sm"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Proven Results</h3>
                  <p className="text-gray-600">
                    Our campaigns consistently deliver 3x average ROI with measurable impact on your bottom line.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 flex items-center justify-center bg-orange-500 rounded-full">
                  <i className="ri-team-line text-white text-sm"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Expert Team</h3>
                  <p className="text-gray-600">
                    Certified professionals with deep expertise in Google, Facebook, and native advertising platforms.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 flex items-center justify-center bg-orange-500 rounded-full">
                  <i className="ri-bar-chart-line text-white text-sm"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Data-Driven Approach</h3>
                  <p className="text-gray-600">
                    Every decision is backed by comprehensive analytics and continuous performance optimization.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/c736934a4c492301ccac400f3538ab86.jpg"
              alt="Marketing team at work"
              className="rounded-lg shadow-lg object-cover w-full h-96"
            />
            <div className="absolute -bottom-6 -left-6 bg-orange-500 text-white p-6 rounded-lg shadow-xl">
              <div className="text-3xl font-bold">5+</div>
              <div className="text-sm">Years Experience</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
